export default "__VITE_ASSET__DXEn8siI__"